import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 230px;
  min-height: 220px;
  background: transparent;
  border-radius: 10px;
  border: 1px solid var(--color-border);
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  cursor: pointer;

  :hover {
    border: 1px solid #858dbd;
    .button {
      text-decoration: underline;
    }
  }

  .divider {
    margin: 10px 0;
  }

  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
    text-transform: capitalize;
    color: var(--color-text-muted);
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .text {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: var(--color-text-subtle);
  }

  .button {
    color: #7cb1fe;
    font-weight: 500;
    font-size: 16px;
    line-height: 34px;
    text-align: center;
    text-decoration: none;
    text-decoration-style: solid;
    height: 40px;
    width: calc(100% - 40px);
    margin: 0;
    display: block;
    bottom: 0;
    position: absolute;
    border-top: 1px solid #d5ddf2;
  }
`;
